import moment from "moment";
import { buildSearchQuery } from "./searchQuery";

export const FORECAST_SEARCHABLE_FIELDS = [
  "code",
  "type",
  "expectedPeriod",
  "status",
];

export function getCurrentExpectedPeriod(now = moment()) {
  return moment(now).format("YYYYMM");
}

export function toExpectedPeriod(value) {
  if (!value) return "";
  const digits = String(value).replace(/\D/g, "");
  return digits.length === 6 ? digits : "";
}

export function formatExpectedPeriod(period) {
  const yyyymm = toExpectedPeriod(period);
  if (!yyyymm) return period || "-";
  return `${yyyymm.slice(0, 4)}-${yyyymm.slice(4)}`;
}

export function buildUpcomingMonthOptions(now = moment(), months = 24) {
  const start = moment(now).startOf("month");
  return Array.from({ length: months }, (_, i) => {
    const month = start.clone().add(i, "months");
    return {
      label: month.format("YYYY-MM"),
      value: month.format("YYYYMM"),
    };
  });
}

export function buildForecastSearchQuery({
  walletId,
  periodFilter,
  searchText,
  now = moment(),
} = {}) {
  const currentPeriod = getCurrentExpectedPeriod(now);
  const selectedPeriod = toExpectedPeriod(periodFilter);
  const expectedPeriod =
    selectedPeriod && selectedPeriod >= currentPeriod
      ? selectedPeriod
      : { $gte: currentPeriod };

  const query = {
    wallet: walletId,
    status: "OPENING",
    expectedPeriod,
  };

  const textQuery = searchText
    ? buildSearchQuery(searchText, FORECAST_SEARCHABLE_FIELDS)
    : {};
  if (!textQuery || Object.keys(textQuery).length === 0) return query;
  return { $and: [query, textQuery] };
}

export function getForecastOrder(bid) {
  return bid?.order ?? null;
}

export function getForecastDebitNote(bid) {
  return bid?.order?.debitNote || bid?.debitNote || null;
}

export function formatForecastProduct(bid) {
  const order = getForecastOrder(bid);
  const product = bid?.product?.name ? bid.product : order?.product;
  if (product?.name || product?.code) {
    return {
      title: product.name || product.code,
      subtitle: product.cname || "",
    };
  }

  const productCategory = order?.productCategory || product?.category;
  const productType = order?.productType || product?.type;
  if (productCategory?.name || productType?.name) {
    return {
      title: productCategory?.name || productType?.name || "-",
      subtitle: productCategory?.name ? productType?.name || "" : "",
    };
  }

  return { title: "-", subtitle: "" };
}
